import { useTranslation } from "react-i18next";
import { Outlet, useParams } from "react-router-dom";

import { Breadcrumb, Flex, Skeleton } from "antd";
import { Alert } from "components/elements";
import { MainLayout } from "components/layouts";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import { getRemainingLeaveWithIn } from "../../home/services/homeApi";
import useEmployeeContactInfo from "../hooks/useEmployeeContactInfo";
import { getEmployeeWorkInCount, getEmploymentInformation } from "../services/employeeApi";
import { setCurrentEmploymentInProfile, setEmpRemainingLeave, setEmployeeWorkInCount, setIsLoading, setIsLoadingSketon } from "../slices/employeeSlice";
import EmployeeInfoTab from "./EmployeeInfoTab";
import EmployeeMenu from "./EmployeeMenu";

function EmployeeEdit(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation();
  const [selectedMenu, setSelectedMenu] = useState('employee_info');
  const isLoadingSketon = useSelector((state) => state.employee.isLoadingSketon);

  const generalInfo = useSelector(
    (state) => state.employee.currentEmploymentInProfile
  );

  // const currentContactInfo = useSelector((state) => state.employee.currentContactInfo);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentEmployee = useSelector((state) => state.company.currentEmploymentInProfile);
  // const employeeWorkInCount = useSelector((state) => state.employee);
  const param = useParams()
  const useEmployeeContactInfoProps = useEmployeeContactInfo();

  const { remainingLeave } = useSelector((state) => state.employee);

  const menuBreadcrumbMapping = {
    'employee_info': t('employee.employee_info.header'),
    'employment': t('employee.employment.header'),
    'workin': t('employee.workin.header'),
    'performance': t('employee.performance.header'),
    'document': t('employee.document.header'),
    'salary': t('employee.salary.header'),
    'welfare': t('employee.welfare.header')
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];

    if (menuBreadcrumbMapping[lastSegment]) {
      setSelectedMenu(lastSegment);
    }
  }, [window.location.pathname]);

  const getEmploymentInfoCallback = useCallback(
    async () => {
      try {
        dispatch(setIsLoading(true));
        dispatch(setIsLoadingSketon(true));
        const response = await getEmploymentInformation({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: param.id,
          visible: false,
          edit: false
        });
        dispatch(setCurrentEmploymentInProfile(response.data || {}));
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
        dispatch(setIsLoadingSketon(false));
      }
    },
    [param.id, currentCompany]
  );

  const leaveType = [
    {
      name: "Business Leave",
    },
    {
      name: "Annual Leave",
    },
    {
      name: "Sick Leave",
    },
    {
      name: "Business Leave (without pay)",
    },
  ]

  const getDataRemaining = useCallback(
    async (params) => {
      try {
        dispatch(setIsLoading(true));
        const res = await getRemainingLeaveWithIn({
          // companyId: params.currentCompany,
          // employeeId: params.currentEmployee,
          ...params,
          employeeId: params?.currentEmployee ? params?.currentEmployee : currentEmployee,
          listName: leaveType.map(o => o.name)
        })
        dispatch(setEmpRemainingLeave(res.data))
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentEmployee],
  )

  const getDataEmployeeWorkInCount = useCallback(
    async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await getEmployeeWorkInCount({
          companyId: currentCompany,
          employeeId: param.id
        });
        dispatch(setEmployeeWorkInCount(response.data?.content || {}));
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, param.id]
  );

  const handleSelectMenu = (key) => {
    setSelectedMenu(key);
    if (props.onSelectMenu) {
      props.onSelectMenu(key);
    }
  };

  useEffect(() => {
    getEmploymentInfoCallback()
    getDataRemaining({ companyId: currentCompany, employeeId: currentEmployee })
    getDataEmployeeWorkInCount()
  }, [currentCompany, currentEmployee, getDataRemaining, getEmploymentInfoCallback, getDataEmployeeWorkInCount])
  console.log("isLoading Skeleton", isLoadingSketon);

  return (
    <MainLayout>
      <Flex vertical style={{ rowGap: 24 }}>
        <Flex vertical>
          <Breadcrumb
            items={[
              { title: t("home.header"), href: "/" },
              {
                title: t("employee.header"),
                href: "/employee",
              },
              {
                title: menuBreadcrumbMapping[selectedMenu] || t("employee.header"),
              }
            ]} />
          <h2>{menuBreadcrumbMapping[selectedMenu] || t("employee.header")}</h2>
        </Flex>
        <Flex vertical={true} gap={10}>
          <Skeleton loading={isLoadingSketon}>
            <EmployeeInfoTab generalInfo={generalInfo} {...useEmployeeContactInfoProps} remainingLeave={remainingLeave} />
            <EmployeeMenu
              // selectedMenu={props.selectedMenu}
              selectedMenu={selectedMenu}
              onSelectMenu={handleSelectMenu}
            />
            <Outlet />
          </Skeleton>
        </Flex>
      </Flex>
    </MainLayout >
  );
}

export default EmployeeEdit;
